import React, { useState } from 'react';
import { Spin, Button, message, Alert } from 'antd';

import IFrame from '../../../IFrame';

const Player = ({ entry }) => {
  const [ chatControl, setChatControl ] = useState(false);
  const [playerLoading, setPlayerLoading] = useState(true);

  const onSourceReady = () => {
    setPlayerLoading(false);
  };

  let playerContent = null;

  const playlistId = (entry.playlist && entry.playlist.id) || null;
  const videoEmbedId = (entry.videoEmbed && entry.videoEmbed.id) || null;
  const uploadVideoUrl = (entry.uploadVideo && entry.uploadVideo.uploadVideoUrl) || null;
  const channelId = entry && entry.channel && entry.channel.id;

  if (entry) {
    let player, chat, videoPlayerUrl;

    if (entry.isUpcoming) {
      if (!entry.channel) {
        playerContent = message.error('Channel missing for this event');
      } else if (entry.embedType === 'goWebinar') {
        player = entry.goWebinarUrl;
        chat = `https://www.ustream.tv/socialstream/${channelId}`;
      } else {
        player = `https://www.ustream.tv/embed/${channelId}?html5ui&autoplay=true`;
        chat = `https://www.ustream.tv/socialstream/${channelId}`;
      }
    } else {
      if (playlistId) {
        player = `https://www.ustream.tv/combined-embed/playlist/${playlistId}?html5ui`;
      } else if (videoEmbedId) {
        player = `https://www.ustream.tv/embed/recorded/${videoEmbedId}?html5ui`;
      } else if (uploadVideoUrl) {
        player = null;
        videoPlayerUrl = uploadVideoUrl;
      } else {
        player = entry.youTubeUrl
      }
    }

    let playerElement;
    if (player) {
      playerElement = (
        <div className="player-container">
          <IFrame className="player" url={player} onload={onSourceReady} title="player"/>
          {playerLoading ? <Spin className="preloader"/> : null}
        </div>
      );
    } else if (videoPlayerUrl) {
      playerElement = (
        <div className="video-player-container">
          <video controls>
            <source src={videoPlayerUrl} type="video/mp4" />
            <source src={videoPlayerUrl} type="video/ogg" />
            <source src={videoPlayerUrl} type="video/webm" />
          </video>
        </div>
      )
    } else {
      playerElement = <Alert message="Content isn't available yet" type="warning"/>;
    }

    const ChatButton = ({ chatControl }) => {
      const chatButtonText = chatControl ? 'Hide chat' : 'Show chat';

      return (
        <Button
          className="chat-button"
          name="chatButton"
          onClick={() => setChatControl(!chatControl)}
        >
          {chatButtonText}
        </Button>
      )
    };

    playerContent = (
      <div className="watch-container">
        {playerElement}

        <div className={`chat-controls ${chatControl ? '' : 'hidden'}`}>
          <ChatButton chatControl={chatControl}/>

          <div className={`chat-wrapper`}>
            {
              chat ? (
                <IFrame className="chat" url={chat} title="chat"/>
              ) : (
                <iframe
                  title={'video-player'}
                  src={`https://video.ibm.com/socialstream/${channelId}?videos=0`}
                  webkitallowfullscreen
                  allowFullScreen
                  frameBorder="no"
                  width="320"
                  height="478"
                />
              )
            }
          </div>
        </div>
      </div>
    );

    if (entry.isUpcoming) {

    }
    return playerContent;
  }
};

export default Player;



// WEBPACK FOOTER //
// ./src/components/Modules/Info/Player/index.js